import * as PIXI from 'pixi.js';
import TiledLevel from "./lib/TiledLevel";
import {Alien, TilesTypes} from "./Tiles";
import EventManager from "./lib/EventManager";
import state from "./State";

import WallImage from '../assets/whall.png';
import MeteoriteImage from '../assets/meteorite.png';
import SideriteImage from '../assets/siderite.png';
import EndLevelImage from '../assets/button.png';
import BackgroundImage from '../assets/sfondo.jpg';
import * as Events from "./Events";
import {AlienSprite} from "./AlienSprite";

const WallTexture = PIXI.Texture.from(WallImage);
const MeteoriteTexture = PIXI.Texture.from(MeteoriteImage);
const EndLevelTexture = PIXI.Texture.from(EndLevelImage);

const BackgroundTexture = PIXI.Texture.from(BackgroundImage);

const Textures = [
  PIXI.Texture.EMPTY,
  WallTexture,
  EndLevelTexture,
  MeteoriteTexture,
  PIXI.Texture.from(SideriteImage)
]

const createRectangle = (i: number, j: number, state: any) : PIXI.Sprite => {
  const rectangle = new PIXI.Sprite(PIXI.Texture.EMPTY);
  rectangle.x = 32 * i;
  rectangle.y = 32 * j;
  rectangle.width = 32;
  rectangle.height = 32;
  rectangle.interactive = true;
  rectangle.on('mousedown', event => {
    if (state.mode === 'edit') {
      EventManager.emit('set-tile', i, j, state.selectedTile);
    }
  });
  rectangle.on('mouseover', event => {
    if (state.mousePressed && state.mode === 'edit') {
      EventManager.emit('set-tile', i, j, state.selectedTile);
    }
  });

/*  rectangle.rotation = state.angle === 'landscape' ? 0 : 25
  EventManager.on('orientation-changed', (orientation) => {
    console.log(orientation)
    if (orientation === 'portrait') {
      rectangle.rotation = 90
    }
  })*/

  return rectangle;
}

const LevelView = {

  el: new PIXI.Container(),

  greenAlien: new AlienSprite({ id: "green" }),
  yellowAlien: new AlienSprite({ id: "yellow" }),
  redAlien: new AlienSprite({ id: "red" }),

  background: new PIXI.Sprite(BackgroundTexture),

  state: {
    mode: 'play', // edit, play
    selectedTile: TilesTypes.SOLID_1,
    mousePressed: false
  },

  setLevel (level: TiledLevel) {
    this.level = level;
    this.generateBoard();
  },

  init () {
    this.el.interactive = true;

    this.el.on('mousedown', event => {
      this.state.mousePressed = true;
    });

    this.el.on('mouseup', event => {
      this.state.mousePressed = false;
    });

    this.el.on('mouseout', event => {
      this.state.mousePressed = false;
    });

    EventManager.on('update-tile', this.update.bind(this))
    EventManager.on('select-tile', (tile: TilesTypes) => {
      this.state.selectedTile = tile;
    })
    EventManager.on(Events.updateAlienPosition, this.updateAlienPosition.bind(this))

    EventManager.on(Events.setLevel, (level) => {
      this.setLevel(level)
    })
  },

  generateBoard () {
    for (let i = this.el.children.length - 1; i >= 0; i--) {
      this.el.removeChild(this.el.children[i])
    }
    this.el.addChild(this.background)
    this.tileElements = [];
    for (let i = 0; i < this.level.columns; i++) {
      this.tileElements[i] = [];
      for (let j = 0; j < this.level.rows; j++) {
        const rectangle = createRectangle(i, j, this.state);
        this.el.addChild(rectangle);
        this.tileElements[i][j] = rectangle;
        this.update(i, j, this.level.tiles[j * this.level.columns + i])
      }
    }
    if (this.level.greenAlien) {
      this.el.addChild(this.greenAlien)
      this.updateAlienPosition(this.level.greenAlien)
    }
    if (this.level.yellowAlien) {
      this.el.addChild(this.yellowAlien)
      this.updateAlienPosition(this.level.yellowAlien)
    }
    if (this.level.redAlien) {
      this.el.addChild(this.redAlien)
      this.updateAlienPosition(this.level.redAlien)
    }

  },

  update (col, row, value) {
    this.tileElements[col][row].texture = Textures[value];
    this.tileElements[col][row].width = 32;
    this.tileElements[col][row].height = 32;
  },

  updateAlienPosition(alien: Alien) {
    if (alien.id === 'green') {
      this.greenAlien.updatePosition(alien)
    }
    if (alien.id === 'yellow') {
      this.yellowAlien.updatePosition(alien)
    }
    if (alien.id === 'red') {
      this.redAlien.updatePosition(alien)
    }
  }
}

export default LevelView;
